'use client';
import { useEffect, useState } from 'react';

export interface UseMatchesMediaQueryWithResizeParams {
  query: string;
}

export const useMatchesMediaQueryWithResize = ({
  query,
}: UseMatchesMediaQueryWithResizeParams): boolean => {
  const [matches, setMatches] = useState(
    typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  const [mq, setMQ] = useState<MediaQueryList | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const mq = window?.matchMedia(query);
    const callback = (e: MediaQueryListEvent) => setMatches(e.matches);

    // Kick a re-render after page load if the media query result
    // doesn't match the server-side user-agent detection.
    setMatches(mq.matches);

    mq.addEventListener('change', callback);
    setMQ(mq);

    return () => mq?.removeEventListener('change', callback);
  }, [query]);

  useEffect(() => {
    function handleResize() {
      const mq = window?.matchMedia(query);
      setMatches(mq.matches);
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return matches;
};
